/** API route map: URLS.Controller.EmployeeBadges */
export const EmployeeBadges = {
      Name: 'EmployeeBadges/',
      GetEmployeeBadges: 'get-employee-badges-list',
      AddEmployeeBadges: 'add-employee-badge',
      UpdateEmployeeBadges: 'update-employeebadge',
      DeleteEmployeeBadges: 'delete-employeebadge',
      SearchBadges: 'search-badges',
      AssignBadges: 'assign-badges',
      GetAllAndAssignedBadges: 'get-all-and-assigned',
      GetAssignedBadges: 'get-assigned-badges',
};
